import React, {Component} from 'react';
import Header from '../components/Header/Header';
import LeftSidebar from '../components/LeftSidebar/LeftSidebar';

class Main extends Component{
    render(){
        return(
            <div>
                <div id="main-wrapper">
                    <Header />
                    <LeftSidebar />
                </div>
            </div>
        )
    }
}

export default Main;
